import { MeetingViewEnum } from "./header-constants";

export const meetingViewSearchParam = "meetingView";
export const meetingVideoTimeSearchParam = "videoTime";

const meetingViewToSearchValue: Record<MeetingViewEnum, string> = {
  [MeetingViewEnum.notes]: "notes",
  [MeetingViewEnum.summary]: "summary",
  [MeetingViewEnum.previousMeetingSummary]: "last-meeting-recap",
};

const searchValueToMeetingView = Object.fromEntries(
  Object.entries(meetingViewToSearchValue).map(([meetingView, searchValue]) => [
    searchValue,
    meetingView,
  ]),
) as Record<string, MeetingViewEnum>;

export const getMeetingViewFromSearch = (search: string) => {
  const searchValue = new URLSearchParams(search).get(meetingViewSearchParam);
  if (!searchValue) return null;

  return searchValueToMeetingView[searchValue] ?? null;
};

export const getMeetingVideoTimeFromSearch = (search: string) => {
  const videoTime = new URLSearchParams(search).get(
    meetingVideoTimeSearchParam,
  );
  if (!videoTime) return null;

  const parsedVideoTime = Number(videoTime);
  if (!Number.isFinite(parsedVideoTime) || parsedVideoTime < 0) return null;

  return parsedVideoTime;
};

export const updateMeetingSearch = ({
  search,
  meetingView,
  videoTimeInSeconds,
}: {
  search: string;
  meetingView?: MeetingViewEnum | null;
  videoTimeInSeconds?: number | null;
}) => {
  const params = new URLSearchParams(search);

  if (meetingView) {
    params.set(meetingViewSearchParam, meetingViewToSearchValue[meetingView]);
  } else {
    params.delete(meetingViewSearchParam);
  }

  if (
    typeof videoTimeInSeconds === "number" &&
    Number.isFinite(videoTimeInSeconds)
  ) {
    const normalizedVideoTime = Math.max(
      0,
      Math.round(videoTimeInSeconds * 1000) / 1000,
    );
    params.set(
      meetingVideoTimeSearchParam,
      String(Number(normalizedVideoTime.toFixed(3))),
    );
  } else {
    params.delete(meetingVideoTimeSearchParam);
  }

  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : "";
};
